import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

const ClinicContext = createContext({});

const DEFAULTS = {
  phone: "+91 86083 23094",
  whatsapp: "918608323094",
  email: "revivefamilyclinic281@gmail.com",
  address: "MA Complex, NGO Nagar Main Rd, SSM Nagar, Alappakam, New Perungalathur, Chennai, Tamil Nadu 600063",
  hours: "Monday – Saturday: 6:00 PM – 9:00 PM\nSunday: Holiday",
  instagram: "https://www.instagram.com/revivefamilyclinic?stkn=dDZ4YWNzcGxmMmx6",
  map_url: "https://maps.app.goo.gl/2EqEgDTpV6hmNdW56",
  google_reviews_url: "https://maps.app.goo.gl/2EqEgDTpV6hmNdW56",
};

export const ClinicProvider = ({ children }) => {
  const { data } = useQuery({
    queryKey: ["content"],
    queryFn: async () => (await api.get("/content")).data,
  });
  return (
    <ClinicContext.Provider value={{ ...DEFAULTS, ...(data || {}) }}>
      {children}
    </ClinicContext.Provider>
  );
};

export const useClinic = () => useContext(ClinicContext);

export const waLink = (whatsapp, text = "Hello Revive Family Clinic, I would like to book an appointment.") =>
  `https://wa.me/${(whatsapp || "918608323094").replace(/[^0-9]/g, "")}?text=${encodeURIComponent(text)}`;
